// extracted by mini-css-extract-plugin
export default {"issue-wrapper":"qbr5vkduVTwJg6UnA_n2","issue-name":"w2IvFDZPtAZxXLlRLUUY","risk-label":"P1UuKKHEwz512hy2Zv7Q","effort":"FQ7bnUdJRYWkqGHIOpNa","safe-levels":"jq1Yfu1WPOUG2XiCyYzQ"};